import { Component, OnInit } from '@angular/core';
import { AuthService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MenuService } from '../../services/menu.service';

@Component({
  selector: 'py-menu-registration',
  templateUrl: './menu-registration.component.html',
  standalone: false,
})
export class MenuRegistrationComponent implements OnInit {
  isAnonymous$: Observable<boolean>;
  hasActiveMenuItem$: Observable<boolean>;

  constructor(
    public component: CmsComponentData<any>,
    private authService: AuthService,
    private menuService: MenuService
  ) {}

  ngOnInit() {
    this.isAnonymous$ = this.authService.isUserLoggedIn().pipe(map((s) => !s));
    this.hasActiveMenuItem$ = this.menuService.hasActiveLinkUid();
  }
}
